import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65cdae2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "poster-preview" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "info" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Wil je de poster per e-mail versturen?")
], -1))
const _hoisted_3 = { id: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_header = _resolveComponent("top-header")!
  const _component_submit_button = _resolveComponent("submit-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_header),
    _hoisted_2,
    _createElementVNode("div", {
      id: "poster",
      style: _normalizeStyle({backgroundImage: `url(${_ctx.poster})`})
    }, null, 4),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_submit_button, {
        class: "submit-button",
        onClick: _ctx.restart
      }, {
        default: _withCtx(() => [
          _createTextVNode("Opnieuw")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_submit_button, {
        class: "submit-button",
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode("Verstuur")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}